import { render, staticRenderFns } from "./Notazz.vue?vue&type=template&id=76b79111&"
import script from "./Notazz.vue?vue&type=script&lang=js&"
export * from "./Notazz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports